var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShowLess = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M15.984 7.616h3v1.968h-4.968V4.616h1.968zm-1.968 10.968v-4.968h4.968v1.968h-3v3zm-6-10.968v-3h1.968v4.968H5.016V7.616zm-3 7.968v-1.968h4.968v4.968H8.016v-3z"
})));
export default SvgShowLess;